import { StateCreator } from 'zustand';

export interface CartSlice {
  isLoading: boolean;
  remarks: string;
  reference: string;
  setIsLoading: (isLoading: boolean) => void;
  setRemarks: (remarks: string | undefined) => void;
  setReference: (reference: string | undefined) => void;
  resetCart: () => void;
}

export const createCartSlice: StateCreator<CartSlice> = (set) => ({
  remarks: '',
  reference: '',
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
  setRemarks: (remarks) => set({ remarks: remarks || '' }),
  setReference: (reference) => set({ reference: reference || '' }),
  resetCart: () => set({ remarks: '', reference: '' }),
});
